export default {
    "filters": {
        "fromDate": "From date",
        "toDate": "To date",
        "thisMonth": "This month",
        "lastMonth": "Last month",
        "last30Days": "Last 30 days",
        "dateRange": "Date range",
        "dateIconLabel": {
            "predefinedRange": "Switch to predefined date filters",
            "manualRange": "Switch to manual date filters"
        }
    },
    "actions": {
        "search": "Search",
        "newClient": "New client",
        "newUser": "New user"
    },
    "totals": "Totals",
    "selectClient": "Client",
    "selectClientPlaceholder": "Select a client",
    "selectUserTypePlaceholder": "Select a user type",
    "forbiddenText": "You don't have access to this page",
    "forbiddenTitle": "Forbidden",
    "headerActions": {
        "profile": "My Profile",
        "leave": "Sign Out"
    },
    "requiredField": "Required field",
    "invalidEmail": "Invalid Email"
};